import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import SvgIcon from '@material-ui/core/SvgIcon'
import useStyles from './styled'

function ErrorIcon(props) {
  return (
    <SvgIcon {...props}>
      <g filter="url(#filter0_f)">
        <rect x="4.5" y="4" width="86" height="86" rx="43" stroke="#E1E1E1" stroke-width="2" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.2653 54.2618C45.6843 54.2618 45.3938 54.0207 45.3938 53.5385L45.0587 28.7233C45.0587 28.2411 45.3491 28 45.9302 28H48.9469C49.5279 28 49.8184 28.2411 49.8184 28.7233L49.4161 53.5385C49.4161 54.0207 49.1256 54.2618 48.5446 54.2618H46.2653ZM47.2709 65.5418C46.4665 65.5418 45.8035 65.2757 45.2821 64.7434C44.7607 64.2112 44.5 63.5537 44.5 62.7709C44.5 62.0195 44.783 61.3698 45.3492 60.8219C45.9153 60.274 46.5558 60 47.2709 60C47.986 60 48.6266 60.274 49.1927 60.8219C49.7588 61.3698 50.0418 62.0195 50.0418 62.7709C50.0418 63.5537 49.7737 64.2112 49.2374 64.7434C48.7011 65.2757 48.0456 65.5418 47.2709 65.5418Z"
        fill="#AE2025"
      />
      <defs>
        <filter
          id="filter0_f"
          x="0.781718"
          y="0.281718"
          width="93.4366"
          height="93.4366"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.35914" result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </SvgIcon>
  )
}

function FacebookIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id="FB"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7ZM14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7.3951 9.6701H6.25553V6.95009H5.61731V5.9919H6.25553V5.37033C6.25553 4.92553 6.43599 4.23028 7.45215 4.23028L8.36769 4.2334V5.16567H7.59279C7.48463 5.16567 7.3951 5.18418 7.3951 5.39605V5.9919H8.38274L8.27479 6.95009H7.3951V9.6701Z"
      />
    </SvgIcon>
  )
}
function LineIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="LIne">
        <circle id="Oval" cx="7" cy="7" r="6.75" stroke="#9B9B9B" stroke-width="0.5" />
        <path
          id="Fill 9"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.25382 6.7306C8.25382 6.17442 8.25764 5.72133 8.25255 5.26824C8.25 5.02133 8.31618 4.82533 8.6 4.83169C8.866 4.83678 8.92073 5.03024 8.92073 5.25806C8.91818 6.04969 8.93091 6.84006 8.90928 7.63042C8.90418 7.77678 8.78582 8.00969 8.67764 8.03897C8.55546 8.07078 8.33782 7.95369 8.24364 7.83533C7.83509 7.32242 7.45709 6.78533 6.97982 6.26606C6.97982 6.59951 6.97982 6.93297 6.97982 7.26642C6.97982 7.42297 7.02055 7.59733 6.96328 7.72842C6.90473 7.8646 6.74946 7.95878 6.63746 8.07078C6.528 7.95497 6.33328 7.84424 6.32437 7.72078C6.29 7.18369 6.30909 6.64406 6.30782 6.10442C6.30782 5.81678 6.28364 5.52533 6.31928 5.24278C6.33709 5.10024 6.43764 4.89406 6.54582 4.85969C6.65782 4.82278 6.87546 4.91951 6.96073 5.02642C7.34128 5.50369 7.69128 6.00515 8.05273 6.49642C8.09346 6.55242 8.14309 6.60206 8.25382 6.7306Z"
          fill="#9B9B9B"
        />
        <path
          id="Fill 11"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.4833 5.50355V6.12719C10.7226 6.12719 10.9466 6.12464 11.1706 6.12846C11.4289 6.13228 11.7598 6.07246 11.7497 6.47082C11.7407 6.86282 11.4086 6.79282 11.1527 6.80046C10.9402 6.80682 10.7277 6.80173 10.4909 6.80173V7.4241C10.7684 7.4241 11.0509 7.42664 11.3322 7.4241C11.5613 7.42155 11.7484 7.4801 11.7547 7.74864C11.7611 8.01592 11.5778 8.09228 11.35 8.09482C10.9784 8.09864 10.6055 8.0961 10.2338 8.09737C9.94238 8.09737 9.79729 7.9701 9.79984 7.66082C9.80875 6.85646 9.80747 6.05337 9.80111 5.24901C9.79984 4.96264 9.93093 4.83028 10.2135 4.83155C10.5978 4.83282 10.9822 4.83155 11.3653 4.83282C11.5855 4.83282 11.7484 4.91555 11.7547 5.1561C11.7624 5.42337 11.5804 5.50101 11.3513 5.50228C11.0675 5.5061 10.7837 5.50355 10.4833 5.50355Z"
          fill="#9B9B9B"
        />
        <path
          id="Fill 13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.46545 7.41425C3.79 7.41425 4.07381 7.41552 4.35763 7.41425C4.57399 7.41298 4.74327 7.48043 4.75345 7.72607C4.76618 7.98952 4.5969 8.08116 4.36399 8.08371C3.9809 8.08752 3.59781 8.08625 3.21472 8.08498C2.93981 8.08371 2.79854 7.95771 2.79981 7.66752C2.80618 6.85425 2.80363 6.03971 2.80236 5.22643C2.80109 5.00498 2.87618 4.8408 3.11672 4.83189C3.37636 4.82298 3.46672 4.98716 3.46545 5.22771C3.4629 5.81443 3.46545 6.40116 3.46545 6.98662C3.46545 7.11516 3.46545 7.24371 3.46545 7.41425Z"
          fill="#9B9B9B"
        />
        <path
          id="Fill 15"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.27231 6.45522C6.27231 6.86249 6.27103 7.27104 6.27231 7.67831C6.27358 7.90104 6.18958 8.05758 5.94649 8.06394C5.7034 8.07158 5.6054 7.91758 5.60412 7.69613C5.60158 6.85613 5.5914 6.01613 5.61812 5.1774C5.62321 5.05649 5.80521 4.86558 5.93121 4.83885C6.15521 4.79304 6.27103 4.96867 6.27231 5.19522C6.27358 5.61522 6.27231 6.03522 6.27231 6.45522Z"
          fill="#9B9B9B"
        />
      </g>
    </SvgIcon>
  )
}
function PhoneIcon(props) {
  return (
    <SvgIcon {...props}>
      <g id="phone">
        <circle id="Oval" cx="7" cy="7" r="6.75" stroke="#9B9B9B" stroke-width="0.5" />
        <path
          id="Shape"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.63333 7.65117C8.16667 8.11784 8.16667 8.58451 7.7 8.58451C7.23333 8.58451 6.76667 8.11784 6.3 7.65117C5.83333 7.18451 5.36667 6.71784 5.36667 6.25117C5.36667 5.78451 5.83333 5.78451 6.3 5.31784C6.76667 4.85117 5.36667 3.45117 4.9 3.45117C4.43333 3.45117 3.5 4.85117 3.5 4.85117C3.5 5.78451 4.459 7.67684 5.36667 8.58451C6.27387 9.49217 8.16667 10.4512 9.1 10.4512C9.1 10.4512 10.5 9.51784 10.5 9.05117C10.5 8.58451 9.1 7.18451 8.63333 7.65117Z"
          fill="#9B9B9B"
        />
      </g>
    </SvgIcon>
  )
}

const KickBox = (props) => {
  const { isOpen, onClose, message = 'The entrant code maybe incorrect' } = props
  const classes = useStyles()
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      // TransitionComponent={Transition}
      // fullScreen={fullScreen}
      classes={{ paper: classes.paper, paperWidthXs: classes.paperWidthXs }}
    >
      <div className={classes.rootDialog}>
        <div className={classes.contentSection}>
          <div className={classes.title}>
            <div className={classes.boxIconPage}>
              <ErrorIcon viewBox="0 0 95 94" htmlColor="#FFFFFF" className={classes.iconPage} />
            </div>

            <div
              style={{ display: 'inline' }}
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          </div>
          <ul>
            <li>
              <PhoneIcon viewBox="0 0 14 14" htmlColor="#FFFFFF" className={classes.iconContact} />
              +(66) 2 026 3068 [10.30-18.00 (UTC+7), Mon-Fri]
            </li>
            <li>
              <LineIcon viewBox="0 0 14 14" htmlColor="#FFFFFF" className={classes.iconContact} />
              @ticketmelon
            </li>
            <li>
              <FacebookIcon
                viewBox="0 0 14 14"
                htmlColor="#9B9B9B"
                className={classes.iconContact}
              />
              Ticketmelon
            </li>
          </ul>
        </div>

        <div className={classes.buttonSection}>
          <Grid container justify="center" spacing={1}>
            <Grid item xs={6} sm={4} md={4}>
              <Button className={classes.button} fullWidth onClick={onClose}>
                Close
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </Dialog>
  )
}

export default KickBox
